import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Typography, Box } from '@mui/material';
import ProductList from '../components/ecommerce/productGrid/ProductList';
import { useTranslation } from '@/hooks/useTranslation';
import { useProductContext } from '@/context/EcommerceContext';

const ShopPage: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { refetchPackages } = useProductContext();

  // Оновлювати список пакетів при кожному переході на цю сторінку (за URL)
  useEffect(() => {
    const isShopPage = location.pathname === '/shop' || location.pathname.endsWith('/shop');
    if (isShopPage) {
      refetchPackages();
    }
  }, [location.pathname, refetchPackages]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {t('shop.title')}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        {t('shop.subtitle')}
      </Typography>
      
      <ProductList />
    </Box>
  );
};

export default ShopPage;
